import { registerFragment } from '@redwoodjs/web/apollo';

registerFragment(gql`
  fragment BillGrowerProductFragment on GrowerProduct {
    id
    slug
    flagged
    status
    customFields
    settlementBasis
    productType
    submittedAt
    grower {
      id
      name
      places {
        ...PlaceAttributes
      }
    }
    growerContact {
      id
      name
      email
    }
    fieldTicketId
    harvestedAt
    harvestLocation
    lineItems {
      lot {
        slug
        quantity
        weightPerInventoryUnit
        warehouseId
        repackChildren {
          lot {
            slug
            quantity
            weightPerInventoryUnit
            warehouseId
          }
        }
      }
    }
    shipment {
      id
      terms
      shipDate
      deliveryDate
      origin {
        ...PlaceAttributes
      }
      destination {
        ...PlaceAttributes
      }
      customFields
    }
    documents {
      ...BillDocumentFragment
    }
  }
`);
